const routes = [
  {
    path: '',
    component: () => import('@/views/eden/discipline/Wrapper.vue'),
    children: [
      {
        path: '/eden/discipline',
        name: 'edenDiscipline',
        component: () => import('@/views/eden/discipline/Main.vue'),
      },
      {
        path: '/eden/discipline/:id',
        name: 'edenDisciplineDetails',
        component: () => import('@/views/eden/discipline/Details.vue'),
      },
    ],
  },
]

export default routes
